import EnumSet from 'Services/enumSet'

interface IFirstAccessTypes extends EnumSet {
  quoteRequest: number
  quoteOpportunity: number
  quoteNegotiation: number
}

const FirstAccessTypes = new EnumSet({
  none: { value: 0, description: 'Indefinido' },
  migratedUser: { value: 1, description: 'Usuário migrado' },
  quoteRequest: { value: 2, description: 'Minhas solicitações' },
  quoteOpportunity: { value: 3, description: 'Oportunidades' },
  quoteNegotiation: { value: 4, description: 'Negociações' },
  buildings: { value: 5, description: 'Estabelecimentos' },
}) as IFirstAccessTypes

export default FirstAccessTypes